import React from "react";
import classNames from "classnames";
import NavDesktopItemLevelPair from "./NavDesktopItemLevelPair";
import * as h from "../helpers";

function NavDesktop({ nav, user }) {
  const showDeadLinks = h.getShowDeadLinks(user);

  return (
    <div className="mtt-footer-nav-desktop">
      {nav?.map(category =>
        !showDeadLinks && category.review_state === "private" ? null : (
          <ul className="mtt-fnd-category-container" key={category.title}>
            <li
              className={classNames(
                "mt-text-large mtt-fnd-category-title",
                category.review_state
              )}
            >
              {category.title}
            </li>
            {category.children.map(item => {
              return (
                <NavDesktopItemLevelPair
                  key={item.title + item.order_no}
                  item={item}
                  levelIndex={1}
                  showDeadLinks={showDeadLinks}
                />
              );
            })}
          </ul>
        )
      )}
    </div>
  );
}

export default NavDesktop;
